"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    sliderEmphasisVariants: ()=>sliderEmphasisVariants,
    sliderEmphases: ()=>sliderEmphases,
    emphasisVariants: ()=>emphasisVariants,
    sliderVariants: ()=>sliderVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const sliderEmphasisVariants = {
    regular: '',
    medium: '',
    bold: ''
};
const sliderEmphases = Object.keys(sliderEmphasisVariants);
const emphasisVariants = {
    regular: {
        root: '',
        label: 'text-primary-13',
        valueText: 'text-primary-13',
        track: 'bg-primary-5',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-8
      focus:outline-primary-8
      focus:outline-offset-primary-1
      ring-primary-8
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
    `
    },
    medium: {
        root: '',
        label: 'text-primary-13',
        valueText: 'text-primary-13',
        track: 'bg-primary-5',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-8
      focus:outline-primary-8
      focus:outline-offset-primary-1
      ring-primary-8
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
    `
    },
    bold: {
        root: '',
        label: 'text-primary-1',
        valueText: 'text-primary-1',
        track: 'bg-primary-5',
        indicator: 'bg-primary-8',
        thumb: `
      bg-primary-1
      outline-primary-1
      focus:outline-primary-1
      focus:outline-offset-primary-1
      ring-primary-1
      data-disabled:bg-primary-6 data-disabled:ring-primary-5
   `
    }
};
const sliderVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'flex flex-col',
        label: 'text-body3 flex',
        valueText: 'text-body2 flex justify-between',
        control: 'flex w-full touch-none select-none items-center p-3',
        track: 'hover:bg-primary-6 data-disabled:bg-primary-5 data-disabled:hover:bg-primary-5 data-disabled:hover:cursor-not-allowed h-2 w-full rounded-full hover:cursor-pointer',
        indicator: 'hover:bg-primary-9 data-disabled:bg-primary-5 data-disabled:hover:bg-primary-5 data-disabled:hover:cursor-not-allowed rounded-full hover:cursor-pointer',
        thumb: 'data-disabled:hover:cursor-not-allowed size-5 select-none rounded-full shadow-sm ring-2 transition hover:cursor-pointer hover:shadow-lg hover:transition-all hover:duration-300 focus:outline-2 focus:outline-offset-4',
        marks: 'pointer-events-none absolute inset-0'
    },
    variants: {
        emphasis: emphasisVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular'
    }
});
exports.emphasisVariants = __webpack_exports__.emphasisVariants;
exports.sliderEmphases = __webpack_exports__.sliderEmphases;
exports.sliderEmphasisVariants = __webpack_exports__.sliderEmphasisVariants;
exports.sliderVariants = __webpack_exports__.sliderVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "emphasisVariants",
    "sliderEmphases",
    "sliderEmphasisVariants",
    "sliderVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
